import { useMutation } from "@tanstack/react-query";
import { Button } from "@/components/shadcn/button";
import { downloadExcelFile } from "@/api/excelExport";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

interface ExportToExcelButtonProps {
    mutationFn: () => Promise<{ data: Blob; contentDisposition?: string }>;
    label: string;
    successMessage: string;
    disabled?: boolean;
    className?: string;
}

export const ExportToExcelButton = ({
    mutationFn,
    label,
    successMessage,
    disabled,
    className,
}: ExportToExcelButtonProps) => {
    const exportMutation = useMutation({
        mutationFn,
        onSuccess: (response) => {
            downloadExcelFile(response.data, response.contentDisposition);
            toast.success(successMessage);
        },
        onError: (error) => {
            const errorMessage =
                error instanceof Error ? error.message : "Failed to export Excel file. Please try again.";
            toast.error(errorMessage);
        },
    });

    return (
        <Button
            onClick={() => exportMutation.mutate()}
            disabled={exportMutation.isPending || disabled}
            variant="secondary"
            size="sm"
            className={className}
        >
            {exportMutation.isPending ? (
                <Loader2 className="h-4 w-4 animate-spin mr-1" />
            ) : (
                <Download className="h-4 w-4 mr-1" />
            )}
            {label}
        </Button>
    );
};
